import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { streamInitialState } from './stream.constant';
import { StreamAction } from './stream.action';

export const streamReducer = reducerWithInitialState(streamInitialState)
  .cases([StreamAction.loadList.started, StreamAction.processing.started], (state) => {
    return {
      ...state,
      listNetworkStatus: NetworkStatus.Started,
    };
  })
  .cases([StreamAction.processing.done, StreamAction.processing.failed], (state) => {
    return {
      ...state,
      listNetworkStatus: NetworkStatus.Done,
    };
  })
  .case(StreamAction.loadList.done, (state, { result }) => {
    const data = {};

    for (const item of result) {
      data[item.streamId] = item;
    }

    return {
      ...state,
      data,
      listNetworkStatus: NetworkStatus.Done,
    };
  })
  .case(StreamAction.loadList.failed, (state) => {
    return {
      ...state,
      listNetworkStatus: NetworkStatus.Failed,
    };
  })
  .case(StreamAction.load.started, (state, { streamId }) => {
    const { data } = state;
    const stream = data[streamId];

    return {
      ...state,
      data: {
        ...data,
        [streamId]: {
          ...stream,
          networkStatus: NetworkStatus.Started,
        },
      },
    };
  })
  .case(StreamAction.load.done, (state, payload) => {
    const { data } = state;
    const { params: { streamId }, result } = payload;
    const stream = data[streamId];

    return {
      ...state,
      data: {
        ...data,
        [streamId]: {
          ...stream,
          ...result,
          clientSymbolsCount: result.clientSymbolsCount ?? stream.clientSymbolsCount,
          networkStatus: NetworkStatus.Done,
        },
      },
    };
  })
  .case(StreamAction.load.failed, (state, { params }) => {
    const { data } = state;
    const { streamId } = params;
    const stream = data[streamId];

    return {
      ...state,
      data: {
        ...data,
        [streamId]: {
          ...stream,
          networkStatus: NetworkStatus.Failed,
        },
      },
    };
  })
  .case(StreamAction.remove.done, (state, payload) => {
    const data = { ...state.data };
    delete data[payload.params.streamId];

    return {
      ...state,
      data,
    };
  })
  .case(StreamAction.destroy, () => ({
    ...streamInitialState,
  }));
